import React from "react";
import { useContext } from "react";
import MaterialContext from "../context/material/materialContext";
import Spinner from "./Spinner";

const FacilityList = () => {
  const materialContext = useContext(MaterialContext);

  const { facilities, setFacility, loading } = materialContext;

  if (loading === true || !facilities) {
    return <Spinner />;
  }

  return (
    <div className="list">
      {facilities.map(facility => (
        <div
          key={facility.value}
          className="list-item"
          onClick={() => {
            setFacility(facility);
          }}
        >
          {facility.name}
        </div>
      ))}
    </div>
  );
};

export default FacilityList;
